import { render } from "./DocumentThumbnails.vue?vue&type=template&id=b21f512c&scoped=true"
import script from "./DocumentThumbnails.vue?vue&type=script&lang=js"
export * from "./DocumentThumbnails.vue?vue&type=script&lang=js"

import "../../assets/scss/document_thumbnails.scss?vue&type=style&index=0&id=b21f512c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21f512c"]])

export default __exports__